import { render } from "./AngkutIkan.vue?vue&type=template&id=7f170eb0"
import script from "./AngkutIkan.vue?vue&type=script&lang=js"
export * from "./AngkutIkan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__